 <div style=" background: #395697;  margin: 0 auto; max-width: 1000px; text-align: center; padding-top: 100px; color: #fff; ">
        <div style=" font-size: 50px; ">Oops, You're Offline!</div>
        <div style=" font-size: 20px; padding-top: 40px; ">It looks like your network connection isn't working right
            now.</div>
</div>

